import { OptionType } from '@evinced-private/ui-common';

import { timeOptions } from '../../../helpers/SchedulingHelper';
import { IScheduledJobConfiguration } from '../../../interfaces/ScheduledJobConfiguration';

export const getSelectedTime = (
	config: Pick<IScheduledJobConfiguration, 'hours' | 'minutes'> | undefined
): OptionType[] | undefined => {
	if (config?.hours?.[0] !== undefined && config?.minutes?.[0] !== undefined) {
		const hours = config.hours[0];
		const minutes = config.minutes[0];
		const timeStr = `${hours}:${String(minutes).padStart(2, '0')}`;
		const timeOption = timeOptions.find((opt) => opt.value === timeStr) || timeOptions[0];
		return [timeOption];
	}
	return undefined;
};
